export interface WholeRowPage {
  offset: number;
  height: number;
}

/** Page at measured row boundaries so the unused bottom space never exposes half a name. */
export function wholeRowPages(rowTops: readonly number[], viewportHeight: number, totalHeight: number, rowBottoms?: readonly number[]): WholeRowPage[] {
  if (viewportHeight <= 0 || totalHeight <= 0 || rowTops.length === 0) return [{ offset: 0, height: 0 }];
  const pages: WholeRowPage[] = [];
  const endOf = (index: number) => rowBottoms?.[index] ?? rowTops[index + 1] ?? totalHeight;
  let index = 0;
  while (index < rowTops.length) {
    const start = rowTops[index]!;
    const bottom = endOf(index);
    if (bottom - start > viewportHeight + 0.01) {
      // Only a row taller than the entire panel needs to be split; don't skip its contents.
      for (let offset = start; offset < bottom; offset += viewportHeight) {
        pages.push({ offset, height: Math.min(viewportHeight, bottom - offset) });
      }
      index += 1;
      continue;
    }
    let next = index + 1;
    while (next < rowTops.length && endOf(next) - start <= viewportHeight + 0.01) next += 1;
    pages.push({ offset: start, height: endOf(next - 1) - start });
    index = next;
  }
  return pages;
}
